import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedHeartOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 2.244C16 1.142 15.292.309 14.359.07c-.713-.183-1.486-.007-2.125.526-.639-.533-1.412-.708-2.125-.526-.933.24-1.64 1.073-1.64 2.174 0 .973.66 1.739 1.297 2.286.618.531 1.378.993 1.983 1.36l.485.296.485-.295c.605-.368 1.366-.83 1.983-1.36C15.34 3.982 16 3.216 16 2.243m-3.19-.216c.412-.597.893-.68 1.201-.602.321.082.589.362.589.818 0 .322-.233.729-.81 1.224-.453.39-1.01.744-1.556 1.078-.546-.334-1.103-.689-1.556-1.078-.577-.495-.81-.902-.81-1.224 0-.455.268-.735.589-.817.308-.08.789.004 1.201.601l.576.834z"
                        fill="currentColor"
                    />
                    <path
                        d="M.496 7.247C.496 3.927 2.13.607 7 .499v1.4c-2.043.052-3.238.747-3.951 1.603-.78.936-1.153 2.265-1.153 3.745s.373 2.809 1.153 3.744c.742.89 2.003 1.606 4.197 1.606s3.456-.716 4.198-1.606c.735-.882 1.108-2.114 1.149-3.491h1.4c-.038 1.515-.426 3.013-1.315 4.188L15.5 14.51l-.99.99-2.816-2.816c-1.045.81-2.495 1.313-4.448 1.313-5.062 0-6.75-3.375-6.75-6.75"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierOutlinedHeartOutlinedSize16Glyph.displayName = 'MagnifierOutlinedHeartOutlinedSize16Glyph';
